import React from 'react'

const CardStack = (props) => {

const buttonLink = () => {
  if(props.buttonText){
    return (<div className={`fineryStickerCard ${ props.visibleClass }`} onClick={ props.buttonClickHandler }>{props.buttonText}</div>)
  }
}

const arrowLink = () => {
  if(props.arrowLink){
    //console.log('arrow')
    return (<div onClick={props.onNextPage} className="fineryArrow"></div>)
  }
}

 return (
  <div className="page">
    <div className="fineryCardContainer">
    { arrowLink() }
      <div className="fineryCardFake" ></div>
      {props.children}
    </div>
    { buttonLink() }
  </div>
  )
}
export default CardStack;



// WEBPACK FOOTER //
// ./src/templates/CardStack.js